import React, {createContext, useContext, useState} from 'react';

// Create a new context
const UserContext = createContext();

// Create a custom hook to access the UserContextuseUserContext 
export const useUserContext = () => {
    return useContext(UserContext);
};

// Create a UserProvider component to wrap your application

export const UserProvider = ({children}) => {
    const storedUser = JSON.parse(localStorage.getItem('user'));

    const [user, setUser] = useState(storedUser || null);
    const setUserAndPersist = (user) => {
        localStorage.setItem('user', JSON.stringify(user));
        setUser(user);
    };
    // Function to clear the user and remove it from local storage
    const clearUserAndPersist = () => {
        localStorage.removeItem('user');
        setUser(null);
    };

    return (
        <UserContext.Provider value={{ user, setUser: setUserAndPersist, clearUser: clearUserAndPersist }}>
            {children}
        </UserContext.Provider>
    );
};
